export default require("../../node_modules/.pnpm/ndarray-ops@1.2.2/node_modules/ndarray-ops/ndarray-ops.js");